import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Img = styled.img`
  height: 2.2rem;
  width: auto;
`;

function Logo({ className }) {
  const navigate = useNavigate();

  return (
    <div
      className={cn(
        "flex justify-center items-center m-0 hover:cursor-pointer",
        className
      )}
      onClick={() => navigate("/")}
    >
      <Img src={"/icons8-quill-with-ink-96.png"} alt="Logo" />
    </div>
  );
}

export default Logo;
